/* Wicked Wishes Co - redesign interactions */
(function () {
  var WL_KEY = 'ww-wishlist';
  function getWL() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function setWL(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function money(cents) {
    var c = (window.wwMoney && window.wwMoney.currency) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: c }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function toast(msg) {
    var t = document.querySelector('.ww-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ww-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- cart ---------- */
  function addLines(lines) {
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      return actions.updateCart({
        lines: lines.map(function (l) {
          var attrs = l.properties ? Object.keys(l.properties).filter(function (k) { return l.properties[k]; }).map(function (k) { return { key: k, value: String(l.properties[k]) }; }) : undefined;
          return { merchandiseId: String(l.id), quantity: l.quantity || 1, attributes: attrs };
        })
      }, { event: { context: 'product' } }).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        if (actions.openCart) actions.openCart();
        return res;
      });
    }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map(function (l) { return { id: Number(l.id), quantity: l.quantity || 1, properties: l.properties || {} }; }) })
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); window.location.href = '/cart'; });
  }
  window.wwAddLines = addLines;

  function busy(btn, on) { if (!btn) return; btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }

  document.addEventListener('click', function (e) {
    /* quick add: single variant or size picker */
    var qa = e.target.closest('[data-ww-qa]');
    if (qa) {
      e.preventDefault();
      var card = qa.closest('.ww-card');
      var picker = card && card.querySelector('.ww-qa-sizes');
      if (picker) { card.classList.toggle('is-choosing'); var f = picker.querySelector('button:not([disabled])'); if (f) f.focus(); return; }
      busy(qa, true);
      addLines([{ id: qa.getAttribute('data-variant') }]).catch(function (err) { toast(err.message); }).finally(function () { busy(qa, false); });
      return;
    }
    var add = e.target.closest('[data-ww-add]');
    if (add) {
      e.preventDefault();
      var c2 = add.closest('.ww-card');
      busy(add, true);
      addLines([{ id: add.getAttribute('data-variant') }]).then(function () { if (c2) c2.classList.remove('is-choosing'); }).catch(function (err) { toast(err.message); }).finally(function () { busy(add, false); });
      return;
    }
    /* wishlist toggle */
    var w = e.target.closest('[data-ww-wish]');
    if (w) {
      e.preventDefault();
      var h = w.getAttribute('data-ww-wish'); var list = getWL(); var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      setWL(list); syncWish();
      toast(i > -1 ? 'Removed from your wishlist' : 'Saved to your wishlist');
      return;
    }
    var wo = e.target.closest('[data-ww-wl-open]');
    if (wo) { e.preventDefault(); openWL(); return; }
    if (e.target.closest('[data-ww-wl-close]')) { e.preventDefault(); closeWL(); return; }
    var mo = e.target.closest('[data-ww-menu]');
    if (mo) { e.preventDefault(); var d = document.getElementById('ww-mdrawer'); if (d) { var open = !d.classList.contains('is-open'); d.classList.toggle('is-open', open); mo.setAttribute('aria-expanded', open); if (open) { var a = d.querySelector('a,button'); if (a) a.focus(); } } return; }
    if (e.target.closest('[data-ww-menu-close]')) { var d2 = document.getElementById('ww-mdrawer'); if (d2) d2.classList.remove('is-open'); return; }
    /* tabs */
    var tab = e.target.closest('[data-ww-tab]');
    if (tab) {
      var root = tab.closest('[data-ww-tabs]'); var idx = tab.getAttribute('data-ww-tab');
      root.querySelectorAll('[data-ww-tab]').forEach(function (b) { var on = b.getAttribute('data-ww-tab') === idx; b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-ww-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-ww-panel') !== idx; });
      return;
    }
    /* close quick-add pickers when clicking elsewhere */
    document.querySelectorAll('.ww-card.is-choosing').forEach(function (c) { if (!c.contains(e.target)) c.classList.remove('is-choosing'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeWL();
    var d = document.getElementById('ww-mdrawer'); if (d) d.classList.remove('is-open');
    document.querySelectorAll('.ww-card.is-choosing').forEach(function (c) { c.classList.remove('is-choosing'); });
  });

  function syncWish() {
    var list = getWL();
    document.querySelectorAll('[data-ww-wish]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-ww-wish')) > -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-ww-wl-count]').forEach(function (n) { n.textContent = list.length; n.hidden = !list.length; });
  }
  function openWL() {
    var wl = document.getElementById('ww-wl'); if (!wl) return;
    wl.classList.add('is-open');
    var box = wl.querySelector('.ww-wl__items'); var list = getWL();
    var empty = wl.querySelector('[data-ww-wl-empty]');
    box.innerHTML = ''; if (empty) empty.hidden = list.length > 0;
    list.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var a = document.createElement('a'); a.className = 'ww-card'; a.href = p.url || ('/products/' + handle);
        var img = p.featured_image ? '<div class="ww-ph"><img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy"></div>' : '<div class="ww-ph"></div>';
        a.innerHTML = img + '<span class="ww-card__title"></span><span class="ww-card__price"></span>';
        a.querySelector('.ww-card__title').textContent = p.title; a.querySelector('.ww-card__price').textContent = money(p.price);
        box.appendChild(a);
      });
    });
    var c = wl.querySelector('[data-ww-wl-close]'); if (c) c.focus();
  }
  function closeWL() { var wl = document.getElementById('ww-wl'); if (wl) wl.classList.remove('is-open'); }

  /* ---------- name preview ---------- */
  function renderLetters(input) {
    var target = document.getElementById(input.getAttribute('data-ww-word'));
    if (!target) return;
    var max = Number(input.getAttribute('maxlength')) || 8;
    var word = (input.value || '').toUpperCase().replace(/[^A-Z0-9&!? ]/g, '').slice(0, max);
    var shown = word || input.getAttribute('data-fallback') || 'NAME';
    target.innerHTML = '';
    shown.split('').forEach(function (ch) { var s = document.createElement('span'); s.className = 'ww-tile'; s.textContent = ch === ' ' ? ' ' : ch; target.appendChild(s); });
  }
  document.addEventListener('input', function (e) {
    var i = e.target.closest && e.target.closest('[data-ww-word]');
    if (i) renderLetters(i);
  });

  /* ---------- product page ---------- */
  function initPDP(root) {
    var data; try { data = JSON.parse(root.querySelector('[data-ww-variants]').textContent); } catch (e) { return; }
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-ww-price]');
    var sizeLabel = root.querySelector('[data-ww-size-label]');
    var atc = root.querySelector('[data-ww-atc]');
    var qtyEl = root.querySelector('[data-ww-qty]');
    var qty = 1;
    function current() { return data.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || data[0]; }
    function refresh() {
      var v = current();
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      if (sizeLabel) sizeLabel.textContent = v.title;
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? (atc.getAttribute('data-label') + ' · ' + money(v.price * qty)) : atc.getAttribute('data-soldout'); }
      if (qtyEl) qtyEl.textContent = qty;
      updateStack();
    }
    root.addEventListener('change', function (e) {
      if (e.target.name === 'ww-size') { idInput.value = e.target.value; refresh(); var u = new URL(location.href); u.searchParams.set('variant', e.target.value); history.replaceState(null, '', u); }
      if (e.target.matches('[data-ww-perso-toggle]')) { var p = root.querySelector('[data-ww-perso-fields]'); if (p) p.hidden = !e.target.checked; }
      if (e.target.matches('[data-ww-stack-item]')) updateStack();
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ww-inc]')) { qty++; refresh(); }
      if (e.target.closest('[data-ww-dec]')) { qty = Math.max(1, qty - 1); refresh(); }
      var th = e.target.closest('[data-ww-thumb]');
      if (th) {
        var main = root.querySelector('[data-ww-main]');
        main.querySelectorAll('[data-ww-media]').forEach(function (m) { m.hidden = m.getAttribute('data-ww-media') !== th.getAttribute('data-ww-thumb'); });
        root.querySelectorAll('[data-ww-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === th ? 'true' : 'false'); });
      }
      if (e.target.closest('[data-ww-atc]')) {
        e.preventDefault();
        var props = {};
        var on = root.querySelector('[data-ww-perso-toggle]');
        var word = root.querySelector('[data-ww-perso-input]');
        if (word && (!on || on.checked) && word.value.trim()) props[word.getAttribute('data-key') || 'Name'] = word.value.trim();
        if (word && word.required && (!on || on.checked) && !word.value.trim()) { word.focus(); toast('Add your word first'); return; }
        var btn = e.target.closest('[data-ww-atc]'); busy(btn, true);
        addLines([{ id: idInput.value, quantity: qty, properties: props }]).catch(function (err) { toast(err.message); }).finally(function () { busy(btn, false); refresh(); });
      }
      if (e.target.closest('[data-ww-stack-add]')) {
        e.preventDefault();
        var lines = [{ id: idInput.value, quantity: 1 }];
        root.querySelectorAll('[data-ww-stack-item]:checked').forEach(function (c) { lines.push({ id: c.value, quantity: 1 }); });
        var b2 = e.target.closest('[data-ww-stack-add]'); busy(b2, true);
        addLines(lines).catch(function (err) { toast(err.message); }).finally(function () { busy(b2, false); });
      }
    });
    function updateStack() {
      var line = root.querySelector('[data-ww-stack-line]'); if (!line) return;
      var checked = root.querySelectorAll('[data-ww-stack-item]:checked');
      var sum = current().price; checked.forEach(function (c) { sum += Number(c.getAttribute('data-price')); });
      var count = 1 + checked.length; var need = Number(line.getAttribute('data-min')) || 3; var pct = Number(line.getAttribute('data-pct')) || 15;
      line.textContent = count >= need ? (count + ' pieces: ' + money(sum) + ' → ' + money(Math.round(sum * (100 - pct) / 100))) : ('Add ' + (need - count) + ' more to save ' + pct + '%');
      var n = root.querySelector('[data-ww-stack-count]'); if (n) n.textContent = count;
    }
    refresh();
  }

  /* ---------- collection ---------- */
  function initCollection(root) {
    var form = root.querySelector('[data-ww-filter-form]');
    if (form) form.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    var sort = root.querySelector('[data-ww-sort]');
    if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
    var tog = root.querySelector('[data-ww-filter-toggle]');
    if (tog) tog.addEventListener('click', function () { var f = root.querySelector('.ww-filters'); var o = !f.classList.contains('is-open'); f.classList.toggle('is-open', o); tog.setAttribute('aria-expanded', o); });
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-ww-more]'); if (!more) return;
      e.preventDefault(); busy(more, true);
      fetch(more.getAttribute('href')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-ww-grid]');
        doc.querySelectorAll('[data-ww-grid] > [data-ww-item]').forEach(function (n) { grid.appendChild(document.importNode(n, true)); });
        var nm = doc.querySelector('[data-ww-more]');
        var shown = grid.querySelectorAll('[data-ww-item]').length; var total = Number(root.getAttribute('data-total')) || shown;
        var sc = root.querySelector('[data-ww-shown]'); if (sc) sc.textContent = shown;
        var pb = root.querySelector('[data-ww-progress]'); if (pb) pb.style.width = Math.min(100, shown / total * 100) + '%';
        if (nm) { more.setAttribute('href', nm.getAttribute('href')); busy(more, false); } else { more.remove(); }
        syncWish();
      }).catch(function () { location.href = more.getAttribute('href'); });
    });
  }

  function init() {
    syncWish();
    document.querySelectorAll('[data-ww-word]').forEach(renderLetters);
    document.querySelectorAll('[data-ww-pdp]').forEach(initPDP);
    document.querySelectorAll('[data-ww-collection]').forEach(initCollection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
